import { Typography } from '@mui/material';
import { confluencePageUrl } from '../../content';
import type { ViewInConfluenceProps } from './types';

/**
 * The way back to the page this record was extracted from.
 *
 * **It opens in a new tab, and that is why the arrow is there.** The catalog is
 * a reading tool and Confluence is where the content is edited; sending someone
 * out of the app mid-read loses their place. `rel="noreferrer"` goes with
 * `target="_blank"` — without it the opened page can reach back through
 * `window.opener`.
 *
 * **The arrow is `aria-hidden` and the accessible name says "opens in a new
 * tab" instead.** A screen reader announcing "north east arrow" tells nobody
 * anything; the behaviour it stands for is the part worth saying.
 */
export const ViewInConfluence = ({ confluencePageId }: ViewInConfluenceProps) => (
  <Typography
    component="a"
    variant="caption"
    href={confluencePageUrl(confluencePageId)}
    target="_blank"
    rel="noreferrer"
    aria-label="View in Confluence, opens in a new tab"
    sx={{
      fontWeight: 500,
      color: 'text.link',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      '&:hover': { textDecoration: 'underline' },
    }}
  >
    View in Confluence <span aria-hidden>&#8599;</span>
  </Typography>
);
